interface MediaItem {
  title: string;
  desc: string;
  duration: string;
  img: string;
  imgAlt: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '庆余年第三季·终极预告',
    desc: '范闲身世揭晓，京都风云再起',
    duration: '02:38',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20drama%20trailer%20scene%20with%20a%20hero%20holding%20a%20sword%20in%20dramatic%20lighting%2C%20palace%20background%2C%20epic%20atmosphere%2C%20warm%20golden%20tones%2C%20film%20poster%20quality%2C%20dramatic%20shadows&width=800&height=450&seq=juzi-media-01&orientation=landscape',
    imgAlt: '庆余年第三季预告片',
  },
  {
    title: '长相思2·虐心名场面合集',
    desc: '小夭抉择，三界为之动容',
    duration: '05:12',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20scene%20with%20a%20woman%20in%20flowing%20white%20silk%20dress%20standing%20in%20a%20magical%20forest%2C%20glowing%20fireflies%2C%20soft%20moonlight%2C%20dreamy%20romantic%20atmosphere%2C%20peach%20and%20gold%20tones&width=800&height=450&seq=juzi-media-02&orientation=landscape',
    imgAlt: '长相思2名场面',
  },
  {
    title: '墨雨云间·悬疑高能片段',
    desc: '层层反转，真相扑朔迷离',
    duration: '03:45',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20ancient%20Chinese%20interior%20with%20candlelight%2C%20shadowy%20figure%20behind%20a%20silk%20screen%2C%20ink%20paintings%20on%20walls%2C%20suspenseful%20atmosphere%2C%20rain%20on%20paper%20windows%2C%20warm%20amber%20candle%20glow&width=800&height=450&seq=juzi-media-03&orientation=landscape',
    imgAlt: '墨雨云间悬疑片段',
  },
  {
    title: '国漫大赏·斗破苍穹新季PV',
    desc: '萧炎突破斗宗，特效炸裂',
    duration: '01:56',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20epic%20scene%20with%20a%20warrior%20surrounded%20by%20glowing%20energy%20flames%2C%20dynamic%20action%20pose%2C%20vibrant%20orange%20and%20gold%20energy%20effects%2C%20dramatic%20composition%2C%20modern%20donghua%20style%20art&width=800&height=450&seq=juzi-media-04&orientation=landscape',
    imgAlt: '斗破苍穹新PV',
  },
];

export default function Media() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            精彩视频
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">精彩片段 · 先睹为快</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            热门剧集预告与高能名场面，快速了解精彩内容。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article key={item.title} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/45 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded-md font-medium">
                  {item.duration}
                </span>
              </div>
              <h3 className="mt-3 text-sm md:text-base font-bold text-foreground-950 line-clamp-1">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}